import { ProcessingEvent } from "../model/processing/processing-event.model";
import * as ProcessingActions from './processing.actions';


export class ProcessingContext {
  DataLastUpdated: ProcessingEvent;
}

export const initialState: ProcessingContext = {
  DataLastUpdated: null
};

export function processingReducer(state = initialState, action: ProcessingActions.ProcessingActions): ProcessingContext {
  switch (action.type) {

    case ProcessingActions.DATA_UPDATED:
      return {
        ...state,
        DataLastUpdated: action.payload
      };
    default:
      return state;
  }
}
